import ChartActionId from '@/common/enums/chart-action-id.enum';
import ChartGroupActionType from '@/common/enums/chart-group-action-type.enum';
import ChartType from '@/common/enums/chart-type.enum';
import ChartAction from '@/common/models/chart/ChartAction';
import ChartGroupAction from '@/common/models/chart/ChartGroupAction';
import i18n from '@/vueI18n';

export default class ChartTypeGroupActions {
  static get defaultOptions(): ChartAction[] {
    return [
      new ChartAction(ChartType.LINE, true, i18n.global.t('messages.chartGroupActionChartTypeLine'), 0),
      new ChartAction(ChartType.BAR, false, i18n.global.t('messages.chartGroupActionChartTypeBar'), 1),
      new ChartAction(ChartType.PIE, false, i18n.global.t('messages.chartGroupActionChartTypePie'), 2),
      new ChartAction(ChartType.CANDLESTICK, false, i18n.global.t('messages.chartGroupActionChartTypeCandlestick'), 3),
    ];
  }

  static getActions(
    rank: number,
    isHighlighted: boolean,
    optionsList?: ChartType[],
    selectedOption?: ChartType,
  ): ChartGroupAction {
    const options = optionsList?.length
      ? optionsList.map((o) => ({
          ...ChartTypeGroupActions.defaultOptions.find((d) => d.id === o),
          isSelected: selectedOption === o,
        }))
      : ChartTypeGroupActions.defaultOptions;

    return new ChartGroupAction(
      ChartActionId.TYPE,
      ChartGroupActionType.CHART_TYPE,
      i18n.global.t('messages.chartGroupActionChartType'),
      rank,
      options,
      isHighlighted,
      true,
    );
  }
}
